<template>
  <div class="flex q-gutter-x-sm text-100">
    <div class="text-blue-grey-6" v-if="label">
      {{ label }}
    </div>
    <div class="text-bold" v-if="value">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PropertyItem",
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
